import { Outlet, createFileRoute } from '@tanstack/react-router';

import { VStack } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';

import { Header } from './$id/-header/-components';

export const Route = createFileRoute('/_staff/public-ids/$id')({
  component: PublicIdDetailLayout,
});

function PublicIdDetailLayout() {
  const { t } = useTranslation(defaultNS, { keyPrefix: 'pages.publicIds' });
  const { id } = Route.useParams();
  useDocumentTitle(`${t('detail.pageTitle')} - ID: ${id}`);

  return (
    <VStack>
      <Header />
      <Outlet />
    </VStack>
  );
}
